 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"aftersales~b2border~b2corder~distribution~manage~stp":"aftersales~b2border~b2corder~distribution~manage~stp","aftersales":"aftersales","b2border":"b2border","b2corder~distribution~products~stockallot~transfer~virtualstore":"b2corder~distribution~products~stockallot~transfer~virtualstore","b2corder~distribution~stp":"b2corder~distribution~stp","b2corder~stp":"b2corder~stp","b2corder":"b2corder","distribution":"distribution","stp":"stp","home~manage":"home~manage","manage":"manage","allotment":"allotment","plan~proddevelop~products~purchase~setting":"plan~proddevelop~products~purchase~setting","home~proddevelop~products":"home~proddevelop~products","plan~products~purchase":"plan~products~purchase","products":"products","stockallot":"stockallot","transfer":"transfer","virtualstore":"virtualstore","home":"home","intercept":"intercept","notice":"notice","package":"package","proddevelop":"proddevelop","plan":"plan","purchase":"purchase","setting":"setting","rules":"rules","sfpCalculation":"sfpCalculation","shipment":"shipment","stockdistribution":"stockdistribution"}[chunkId]||chunkId) + "-legacy." + {"aftersales~b2border~b2corder~distribution~manage~stp":"5b1f8eb4","aftersales":"18a99fee","b2border":"7c736922","b2corder~distribution~products~stockallot~transfer~virtualstore":"e74cf5e1","b2corder~distribution~stp":"a4ee458c","b2corder~stp":"c2f870cd","b2corder":"cf06244f","distribution":"26b49188","stp":"2880ef5c","home~manage":"2956a7cb","manage":"63e024d5","allotment":"acc81a39","plan~proddevelop~products~purchase~setting":"4652cf55","home~proddevelop~products":"7fdcdc22","plan~products~purchase":"eecfcaed","products":"8428badb","stockallot":"482874aa","transfer":"7e9b481b","virtualstore":"d235b7c9","chunk-427ad768":"076f1304","home":"551174b4","intercept":"2df41274","notice":"50605305","package":"0548b548","proddevelop":"59da82da","plan":"4a0f32f8","purchase":"19eeb5fa","setting":"328424d3","rules":"f81f260a","sfpCalculation":"ba381361","shipment":"f380a321","stockdistribution":"4a815edb","chunk-2d0af64d":"801b4c21","chunk-2d0b304f":"b305cc69","chunk-2d0d01d5":"569f793f","chunk-19ae8e22":"823e3f71","chunk-2d0b6d56":"d8bbc965","chunk-2d0c51f8":"fe6da884","chunk-2d0de925":"1c172f9e","chunk-2d215ff9":"a6cd9572","chunk-f46a55ae":"7480605b","chunk-2d0a45db":"e065415d","chunk-2d0a4b7f":"952e0863"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"aftersales":1,"b2corder~distribution~products~stockallot~transfer~virtualstore":1,"b2corder~distribution~stp":1,"b2corder~stp":1,"b2corder":1,"distribution":1,"stp":1,"home~manage":1,"manage":1,"allotment":1,"plan~proddevelop~products~purchase~setting":1,"plan~products~purchase":1,"products":1,"stockallot":1,"virtualstore":1,"intercept":1,"notice":1,"proddevelop":1,"purchase":1,"setting":1,"rules":1,"shipment":1,"stockdistribution":1,"chunk-f46a55ae":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"aftersales~b2border~b2corder~distribution~manage~stp":"aftersales~b2border~b2corder~distribution~manage~stp","aftersales":"aftersales","b2border":"b2border","b2corder~distribution~products~stockallot~transfer~virtualstore":"b2corder~distribution~products~stockallot~transfer~virtualstore","b2corder~distribution~stp":"b2corder~distribution~stp","b2corder~stp":"b2corder~stp","b2corder":"b2corder","distribution":"distribution","stp":"stp","home~manage":"home~manage","manage":"manage","allotment":"allotment","plan~proddevelop~products~purchase~setting":"plan~proddevelop~products~purchase~setting","home~proddevelop~products":"home~proddevelop~products","plan~products~purchase":"plan~products~purchase","products":"products","stockallot":"stockallot","transfer":"transfer","virtualstore":"virtualstore","home":"home","intercept":"intercept","notice":"notice","package":"package","proddevelop":"proddevelop","plan":"plan","purchase":"purchase","setting":"setting","rules":"rules","sfpCalculation":"sfpCalculation","shipment":"shipment","stockdistribution":"stockdistribution"}[chunkId]||chunkId) + "." + {"aftersales~b2border~b2corder~distribution~manage~stp":"31d6cfe0","aftersales":"24ebfac1","b2border":"31d6cfe0","b2corder~distribution~products~stockallot~transfer~virtualstore":"56edf31b","b2corder~distribution~stp":"74865ca6","b2corder~stp":"94d461d4","b2corder":"f8259590","distribution":"b7e9f4bd","stp":"678f90bd","home~manage":"fb2312a9","manage":"8d6d4ad3","allotment":"cbdee27a","plan~proddevelop~products~purchase~setting":"aabae789","home~proddevelop~products":"31d6cfe0","plan~products~purchase":"6ccb4a14","products":"89c263d8","stockallot":"67136931","transfer":"31d6cfe0","virtualstore":"ced21297","chunk-427ad768":"31d6cfe0","home":"31d6cfe0","intercept":"ff083880","notice":"104a10ba","package":"31d6cfe0","proddevelop":"eddb9f59","plan":"31d6cfe0","purchase":"8005aa19","setting":"397747be","rules":"b7708c48","sfpCalculation":"31d6cfe0","shipment":"6ec0db9e","stockdistribution":"3dada3a9","chunk-2d0af64d":"31d6cfe0","chunk-2d0b304f":"31d6cfe0","chunk-2d0d01d5":"31d6cfe0","chunk-19ae8e22":"31d6cfe0","chunk-2d0b6d56":"31d6cfe0","chunk-2d0c51f8":"31d6cfe0","chunk-2d0de925":"31d6cfe0","chunk-2d215ff9":"31d6cfe0","chunk-f46a55ae":"a780dbe8","chunk-2d0a45db":"31d6cfe0","chunk-2d0a4b7f":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
